var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.833 2.5c0-.46.373-.833.833-.833h5.833c.46 0 .834.373.834.833v5.833c0 .46-.373.834-.834.834h-5.833a.833.833 0 0 1-.833-.834zm1.666.833V7.5h4.167V3.333zm-10 7.5a.833.833 0 0 0-.833.834V17.5c0 .46.373.833.833.833h5.834c.46 0 .833-.373.833-.833v-5.833a.833.833 0 0 0-.833-.834zm.834 5.834V12.5h4.166v4.167zm8.333-5.834a.833.833 0 0 0-.833.834V17.5c0 .46.373.833.833.833h5.833c.46 0 .834-.373.834-.833v-5.833a.833.833 0 0 0-.834-.834zm.833 5.834V12.5h4.167v4.167zm-10-15a.833.833 0 0 0-.833.833v5.833c0 .46.373.834.833.834h5.834c.46 0 .833-.373.833-.834V2.5a.833.833 0 0 0-.833-.833zM3.333 7.5V3.333h4.166V7.5z",
    clipRule: "evenodd"
  })));
};
export default SvgGrid;